module.exports = __webpack_public_path__ + "static/media/token-logo.870301d8.png";